export default "__VITE_ASSET__HEuoig_j__"